import { Box } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

import { Txt } from '@app/components/common';
import { FieldComponentProps } from '@app/components/common/types';
import { getDays, VisitFrequencyView } from '@app/components/common/visit-frequency';

import { MasterOutletFormInstance } from '../types';

export const PreviousValue: FC<PropsWithChildren & FieldComponentProps & {
  instance: Partial<MasterOutletFormInstance>,
  origin: Partial<MasterOutletFormInstance>
}> = ({instance, origin, id, children}) => {
  if(!origin) {
    return <>{children}</>;
  }
  if(id === 'visits_day') {
    if (origin[id] !== instance[id]) {
      const [_, days] = getDays(origin[id]);
      return <Box __css={inputStyle}>
        {children}
        <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <VisitFrequencyView days={days} />
        </Box>
      </Box>;
    }
  }
  if(typeof origin[id] === 'string' || typeof instance[id] === 'string') {
    if (origin[id] !== instance[id]) {
      return <Box __css={inputStyle}>
        {children}
        <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{origin[id] || 'пусто'}</Txt>
        </Box>
      </Box>;
    }
  }
  if(origin[id]?.full_address) { // Address
    if (origin[id].full_address?.toLowerCase() !== instance[id]?.full_address?.toLowerCase()) {
      return <Box __css={inputStyle}>
        {children}
        <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{origin[id]?.full_address || ''}</Txt>
        </Box>
      </Box>;
    } else {
      return <>{children}</>;
    }
  }
  if(id === 'channel') {
    if (origin[id]?.name?.toLowerCase() !== instance[id]?.name?.toLowerCase()) {
      return <Box __css={inputStyle}>
        {children}
        <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{origin[id]?.name || ''}</Txt>
        </Box>
      </Box>;
    } else {
      return <>{children}</>;
    }
  }
  if(origin[id]?.id) { // EntityBase
    if (origin[id].id !== instance[id]?.id) {
      return <Box __css={inputStyle}>
        {children}
        <Box display="flex" flexDirection="row">
          <Txt color='gray.500'>Текущее значение:&nbsp;</Txt>
          <Txt color='brand.500'>{origin[id]?.name || ''}</Txt>
        </Box>
      </Box>;
    }
  }

  return <>{children}</>;
};

export const inputStyle = {
  '& input': {
    backgroundColor: '#cbffcd',
  },
  '& .chakra-input__group': {
    backgroundColor: '#cbffcd',
  }
};